export default {
  // 可以通过这个接口查询 /api/controls/menu?appType=0&pageType=0
  1: { // editor文档的按钮类别
    name: '组件按钮',
    type: 'button',
    lists: [
      // {
      //   type: 'hex-button', // 组件定义的类型
      //   cateType: 'button',
      //   name: 'iview按钮',
      //   props: {
      //     controlId: '',
      //     innerText: 'iview按钮',
      //     type: 'info',
      //     shape: ''
      //   },
      //   style: {
      //     width: 100,
      //     height: 30
      //   }
      // },
      // {
      //   type: 'hex-select', // 组件定义的类型
      //   cateType: 'select',
      //   name: '下拉框',
      //   props: {
      //     controlId: '',
      //     innerText: 'iview按钮',
      //     type: 'info',
      //     shape: ''
      //   },
      //   style: {
      //     width: 100,
      //     height: 30
      //   }
      // }
    ]
  },
  16: {
    name: '图表组件',
    type: 'chart',
    lists: [
      {
        type: 'hex-g2',
        cateType: 'chart',
        name: 'g2图表',
        props: {
          controlId: '',
        },
        style: {
          width: 330,
          height: 210,
          background: '#000'
        },
        template: `
          <p style="margin-bottom:10px;">g2</p>
            <img src="https://hexyun.oss-cn-beijing.aliyuncs.com/resource/5e4b5ab5a6ff4a554d53c059/68df3e0df1b1b0f4d1eadde43a9a2e80.png" width="100%" height="100%" />
          </div>`
      },
      {
        type: 'hex-chart', // 组件定义的类型
        cateType: 'chart',
        name: '多行进度条',
        props: {
          controlId: '',
        },
        style: {
          width: 330,
          height: 210,
          background: '#000'
        }
      },
      {
        type: 'hex-checkbox', // 组件定义的类型
        cateType: 'checkbox',
        name: '复选框',
        props: {
          controlId: ''
        },
        style: {
          width: 220,
          height: 150
        }
      }
    ]
  },
  10: {
    name: '单选框',
    type: 'radio',
    lists: [{
      type: 'hex-radio',
      cateType: 'radio',
      name: 'Radio单选框',
      props: {
        controlId: '',
        innerText: 'Radio单选框',
        label: 'radio',
        type: '',
        shape: '',
        selected: false
      },
      style: {
        width: '100',
        height: '30'
      }
    }]
  },
  8: {
    name: '页面布局',
    type: 'layout',
    lists: [{
      type: 'hex-layout',
      cateType: 'layout',
      name: '页面布局',
      props: {
        menu: '',
        content: '',
        footer: ''
      },
      style: {
        width: 300,
        height: 300
      }
    }]
  }
}



// WEBPACK FOOTER //
// ./src/constant/controlList.js